import MuiAlert, { AlertColor, AlertProps } from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import React, { useEffect, useState } from 'react';

export interface Notification {
  type: AlertColor;
  message: string;
}

interface NotificationAlert extends AlertProps {
  open?: boolean;
  onClose?: () => void;
  anchorOrigin?: { vertical: 'top' | 'bottom'; horizontal: 'left' | 'right' };
}

const NotificationAlert = React.forwardRef<HTMLDivElement, NotificationAlert>(
  ({ open, anchorOrigin = { vertical: 'bottom', horizontal: 'left' }, ...props }, ref) => {
    const [isOpen, setIsOpen] = useState(false);
    useEffect(() => {
      setIsOpen(!!open);
    }, [open]);

    const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
      if (reason === 'clickaway') return;
      if (props.onClose) props.onClose();

      setIsOpen(false);
    };

    return (
      <Snackbar
        open={isOpen}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={anchorOrigin}
      >
        <MuiAlert {...props} ref={ref} onClose={handleClose} variant="filled" elevation={6}>
          {props.children}
        </MuiAlert>
      </Snackbar>
    );
  }
);

export default NotificationAlert;
